import styled from 'styled-components'

const StyledActionPlansView = styled.div`
  
`

export default StyledActionPlansView
